import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { Footer } from "@/components/site/Footer";
import { LanguageSelect } from "@/components/site/LanguageSelect";
import { LEGAL_DOCS } from "@/lib/legal";

export default function Legal({ doc }) {
  const { title, sections } = LEGAL_DOCS[doc];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);
  return (
    <div data-testid={`legal-page-${doc}`}>
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-5">
          <Link to="/" data-testid="legal-logo-link"><Logo /></Link>
          <div className="flex items-center gap-3">
            <LanguageSelect testId="legal-language-select" />
            <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900"><ArrowLeft className="h-4 w-4" /> Torna al sito</Link>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-5 py-16">
        <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-slate-500">Ultimo aggiornamento: 21 ottobre 2026</p>
        <div className="mt-12 space-y-10">
          {sections.map(([h, t]) => (
            <section key={h}>
              <h2 className="text-lg font-semibold text-slate-900">{h}</h2>
              <p className="mt-2 leading-relaxed text-slate-600">{t}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
